import { useEffect, useState } from 'react';
import MediaAssetDashboard from '../../features/MediaAssets/MediaDashboard/MediaAssetDashboard';
import { observer } from 'mobx-react-lite';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import AssetForm from '../../features/MediaAssets/Form/AssetForm';
import ActivityDetails from '../../features/MediaAssets/Details/ActivityDetails';
import TestErrors from '../../features/Errors/TestError';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NotFound from '../../features/Errors/NotFound';
import ServerError from '../../features/Errors/ServerError';
import { useStore } from '../stores/store';
import LoadingComponent from './LoadingComponent';
import ModalContainer from '../common/modals/ModalContainer';
import ModalSmall from '../common/modals/ModalSmall';
import UserList from '../../features/Users/UserList';
import AccessDenied from '../../features/Errors/AccessDenied';
import PhysicalAssetIdentifier from '../../features/MediaAssets/Form/PhysicalAssetIdentifier';
import CommunicationSetting from '../../features/Messages/CommunicationSetting';
import Message from '../../features/Messages/Message';
import DeviceMasterTable from '../../features/DeviceMaster/DeviceMasterTable';
import VaultMasterForm from '../../features/VaultMaster/VaultMasterForm';
import VaultMasterTable from '../../features/VaultMaster/VaultMasterTable';
import DeviceMasterForm from '../../features/DeviceMaster/DeviceMasterForm';
import Dashboard from '../../features/Dashboard/DashboardContainer/Dashboard';
import RolesAndPermissions from '../../features/rolesAndPermissions';
import CustomerMasterForm from '../../features/CustomerMaster/CustomerMasterForm';
import CustomerMasterTable from '../../features/CustomerMaster/CustomerMasterTable';
import ShelfRackMasterForm from '../../features/ShelfRackMaster/ShelfRackMasterForm';
import ShelfRackMasterTable from '../../features/ShelfRackMaster/ShelfRackMasterTable';
import WorkLevelMasterTable from '../../features/WorkLevelMaster/WorkLevelMasterTable';
import DepartmentMasterForm from '../../features/DepartmentMaster/DepartmentMasterForm';
import DepartmentMasterTable from '../../features/DepartmentMaster/DepartmentMasterTable';
import EditProfile from '../../features/Profile/EditProfilePhoto';
import UserProfile from '../../features/Profile/UserProfile';
import SingUpForm from '../../features/Users/SignUpForm';
import WorkflowSettings from '../../features/Settings/WorkflowSettings/WorkflowAssetType';
import MetaDataReport2 from '../../features/DynamicTable/MetaDataReport2';
import PivotTableMain from '../../features/PivotReports/PivotTableMain';
import Generatelabel from '../common/modals/GenerateLabel/Generatelabel';
import MetaDataConfiguration from '../../features/Settings/MetaDataConfiguration/MetaDataAssetType';
import APISetting from '../../features/Messages/API Setting/APISetting';
import AssignUserScan from '../../features/AssignUserMobile/userScan';
import MovementGate from '../../features/MediaAssets/MovementGate';
import SaveAsPivot from '../../features/PivotReports/SaveAsPivot';
import FilmFestivalReport from '../../features/DynamicTable/FilmFestivalReport';
import TaskKanban from '../../features/TaskKanban/TaskKanban';
import AllocateUser from '../../features/DynamicTable/AllocateUser';
import OfflineDetector from '../../features/MediaAssets/Details/OfflineDetector';
import DynamicMasterTable from '../../features/DynamicMasters/DynamicMasterTable';
import QuickScan from '../../features/QuickScan/QuickScan';
import DashboardConfiguration from '../../features/DashboardConfiguration';
import ShotwiseQC from '../../features/AssetTrackingReport';
import DynamicDashboard from '../../features/DynamicDashboard';
import QcTable from '../../features/Restoration/QcTable';
import TitleWiseSummary from '../../features/Restoration/TitleWiseSummary';
import CommonSummaryReport from '../../features/Restoration/commonSummaryReport';
import MasterRegisterForm from '../../features/CreateMaster';
import NewMasterTableForm from '../../features/newMaster/FormRegister';
import MasterTable from '../../features/DynamicDashboard/dataGrid';
import ElasticSearch from '../../features/ElasticSearch';
import AssetTracking from '../../features/assetTracking';
import QualityHistory from '../../features/Restoration/RejectHistory';
import CustomerCard from '../../features/Vaultloginpageform/CustomerCard';
import HomePage from '../../features/Home/HomePage';
import Vaultloginform from '../../features/Vaultloginpageform/Vaultloginform';
import ManDaysReport from '../../features/CGReports/manDaysReport';
import OperatorPerformance from '../../features/Restoration/operatorPerformance';
import FormMainpage from '../../features/Vaultloginpageform/FormMainpage';
import AssetScan from '../../features/AssignUserMobile/assetScan';
import SmartFlow from '../../features/smartFlow';
import Cutliststatusreport from '../../features/Restoration/Cutliststatusreport';
import QualityTeamTitlewisePerformace from '../../features/Restoration/QualityTeamTitlewisePerformace';
import CommunicationSettingForDyanamicDashboard from '../../features/CommunicationSettingForDynamicDashboard/index';
import FilmAnaysisAndRepairReport from '../../features/FilmAnaysisAndRepairReport';
import EmployeeUnlock from '../../features/ADL/EmployeeUnlock';
import ShiftRoster from '../../features/ADL/ShiftRoster';
import ShiftMaster from '../../features/ADL/ShiftMaster';
import ShiftModify from '../../features/ADL/ShiftModify';
import PCProcessCsvReport from '../../features/PC_Process_CsvReport';
import AssignReportingHeadHierarchy from '../../features/ADL/assingReportingHeadHierarchy';
import NavBar from './NavBar';
import SidebarContainer from '../common/sidebar/SidebarContainer';
import { Container, Sidebar } from 'semantic-ui-react';
import ResetPasswordOnFirstEverLogin from '../../features/Users/ResetPasswordOnFirstEverLogin';
import MarqueeComponent from '../../features/SmartTracker/MarqueeComponent';
import EmployeeDetailsReport from '../../features/Restoration/Report/EmployeeDetailsReport';
import TitleWiseProductionHoursReport from '../../features/Restoration/Report/TitleWiseProductionHoursReport';
import MISProductionAndQualityReport from '../../features/Restoration/Report/MISProductionAndQualityReport';
import ClusterReport from '../../features/Restoration/Report/ClusterReport ';
import TitleDashboardReport from '../../features/Restoration/Report/TitleDashboardReport'
import ClusterCapacityReport from '../../features/Restoration/Report/ClusterCapacityReport'
import DaywiseHoursAnalyzer from '../../features/Restoration/Report/DaywiseHoursAnalyzer'
import RestorationProductivityReport from '../../features/Restoration/Report/RestorationProductivityReport'
import MonthlyProductivityReport from '../../features/Restoration/Report/MonthlyProductivityReport'
import HoneyCombStatusReport from '../../features/Restoration/Report/HoneyCombStatusReport';
import OperationReport from '../../features/Restoration/Report/OperationalReport';
import ClusterWiseOperationalReport from '../../features/Restoration/Report/ClusterWiseOperationalReport';
import CRM_SmartFlow from '../../features/CRM_SmartFlow';
import NFAI_Restoration_SmartFlow from '../../features/NFAI_Restoration_Smartflow/index';
import CreateNewTitleInventory from '../../features/Dashboard/PCPL/RestorationInventory';
import OperatorPerformanceColorization from '../../features/Restoration/OperatorPerformanceColorization';
import ClientCorrectionReport from '../../features/Restoration/Report/ClientCorrection';
import ItAssetListForCRM from '../../features/DynamicTable/ItAssetListForCRM';
import ColorizationMonthlyProductivityReport from '../../features/Restoration/Report/ColorizationMonthlyProductivityReport';
import HoursMissingEmployeeDetails from '../../features/Restoration/Report/HoursMissingEmployeeDetails';
import TitleProductivityReport from '../../features/Restoration/Report/TitleProductivityReport';
import HCDelayUpdate from '../../features/Restoration/Report/HCDelayUpdate'
import ProductionTitleDeactivation from '../../features/Restoration/ProductionTitleDeactivation';
import MultipleDeleteOption from '../../features/Restoration/MultipleDeleteOption';
// import CutlistStatusReport from '../../features/NFAI_Restoration_Smartflow/Reports/CutlistStatusReport';
import CRMAssetTracking from '../../features/Restoration/CRMAssetTrackingReports/CRMAssetTracking';
import NFAITimeSheetProcess from '../../features/MediaAssets/NFAI_Report/NFAI_TimeSheet/NFAITimeSheetProcess';
import NFAI_Cutliststatusreport from '../../features/NFAI_Restoration_Smartflow/NFAI_Cutliststatusreport';
import MepzDataSync from '../../features/DataSync/mepz_sync';
import MepzDashboard from '../../Mepz_Dashboard/dashboard';
import Scan from '../../features/scan/scan';
import ManualHoursAdd from '../../features/Restoration/Report/ManualHoursAdd';
import MonthlyManualHoursAdd from '../../features/Restoration/Report/MonthlyManualHoursAdd';
import NFAIManualHoursAdd from '../../features/Restoration/Report/NFAIManualHoursAdd';
import NFAIMonthlyManualHoursAdd from '../../features/Restoration/Report/NFAIMonthlyManualHoursAdd';
import OperatorPerformanceNFAIReport from '../../features/NFAI_Restoration_Smartflow/OperatorPerformanceNFAIReport';
import NFAIDefectReport from '../../features/Restoration/NFAIDefectReport';
import AllCompletedReport from '../../features/NFAI_Restoration_Smartflow/CutlistCompleteReport/index';
import ProductionDashboard from '../../features/RestorationProductionDashboard';
import QualityCheckPerformanceReport from '../../features/NFAI_Restoration_Smartflow/QualityCheckPerformanceReport';
function App() {
  const location = useLocation();
  const {
    commonStore,
    userStore,
    RolesAndPermissionsIDStore,
    dashboardStore,
    sidebarStore,
    activityStore,
    userStore: { user },
    metaDataStore,
    TrackingReportStore
  } = useStore();
  const { clearSelectedActivity } = activityStore;
  const { rolesIDRegistry, loadRoleIDS, rolesIDs } = RolesAndPermissionsIDStore;
  const [isOffline, setIsOffline] = useState(false);

  var element = document.querySelector(
    '.view-item-details .adh',
  ) as HTMLElement;

  var historyElement = document.querySelector(
    '.activityhistorysmall',
  ) as HTMLElement;

  function reSize() {
    if (window.innerWidth > 1200) {
      element = document.querySelector(
        '.view-item-details .adh',
      ) as HTMLElement;
      var myTargetElemet1 = document.querySelector(
        '.metadata-parent-tab',
      ) as HTMLElement;
      //42 is height of tabs
      if (myTargetElemet1) {
        myTargetElemet1.style.height = element?.offsetHeight - 42 + 'px';
      }
      var myTargetElemet2 = document.querySelector(
        '.MetaDataUser',
      ) as HTMLElement;
      //28 is padding
      if (myTargetElemet2) {
        myTargetElemet2.style.maxHeight =
          myTargetElemet1?.offsetHeight - 28 + 'px';
      }
    }
  }

  const resizeMetadataHeight = (e?: any) => {
    e.stopPropagation();
    // e.preventDefault();
    reSize(); 
  };

  useEffect(() => {
    if (
      window.location.href.includes('/mediaAssets/') &&
      element?.offsetHeight
      // &&
      // !(
      //   commonStore.filterModeTwo?.includes('AVLAVD03') &&
      //   commonStore.filterModeTwo?.includes('AVLAVB11') &&
      //   commonStore.filterModeTwo?.includes('AVLAVD02') &&
      //   window.innerWidth > 1200
      // )
    ) {
      reSize();
    }
    // eslint-disable-next-line
  }, [
    metaDataStore.updateSideComponentHeight,
    activityStore.historyData,
    window.location.href,
    element,
    historyElement,
  ]);

  useEffect(() => {
    if (
      window.location.href.includes('/mediaAssets/')
      // &&
      // !(
      //   commonStore.filterModeTwo?.includes('AVLAVD03') &&
      //   commonStore.filterModeTwo?.includes('AVLAVB11') &&
      //   commonStore.filterModeTwo?.includes('AVLAVD02') &&
      //   window.innerWidth > 1200
      // )
    ) {
      document.addEventListener('DOMContentLoaded', function () {
        reSize();
      });
      window?.addEventListener('click', resizeMetadataHeight, false);
      window?.addEventListener('resize', resizeMetadataHeight, true);
    }
    return () => {
      window.removeEventListener('click', resizeMetadataHeight, false);
      window.removeEventListener('resize', resizeMetadataHeight, true);
      document.removeEventListener(
        'DOMContentLoaded',
        resizeMetadataHeight,
        false,
      );
    };
    // eslint-disable-next-line
  }, [window.location.href]);

  useEffect(() => {
    function updateOnlineStatus() {
      setIsOffline(!navigator.onLine);
    }
    updateOnlineStatus();
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, []);

  useEffect(() => {
    if (
      userStore.user?.customerName !== 'NFAI' ||
      window.innerWidth > 1025 ||
      window.innerWidth < 1020
    ) {
      sidebarStore.getSidebarFormList();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (user?.customerName === 'LVP CMS - AM') {
      commonStore.staticDemoChanges = true;
    } else if (user?.customerName === 'LVP CMS - SOB') {
      commonStore.staticRegisterDemoChanges = true;
    }
    if (user?.customerName === 'PC Technology') {
      commonStore.markLoginStaticRegisterDemoChages = true;
    }
    const customerNames = ['HFC Media Services', 'North Block Inc.', 'Demo Site'];
    if (
      user?.customerName !== undefined &&
      customerNames.includes(user?.customerName)
    ) {
      commonStore.hfcCustomerChanges = true;
    }
    if(user?.customerName === 'Restoration'){
      TrackingReportStore.OperatorRemainter();
      commonStore.RestorationCustomer = true
    }
    if(user?.customerName === 'NFAIReport'){
     commonStore.NFAIReportCustomer = true;
    }
    // eslint-disable-next-line
  }, [user?.customerName, commonStore]);

  useEffect(() => {
    if (user) {
      if (rolesIDRegistry.size <= 1) loadRoleIDS();
    }
    if (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '192.168.100.72' ||
      window.location.hostname === '172.24.224.1' ||
      window.location.hostname === '172.16.0.138' ||
      window.location.hostname === '172.16.0.132' ||
      window.location.hostname === '172.16.0.139' ||
      window.location.hostname === '172.16.0.135' ||
      window.location.hostname === '172.16.0.137' ||
      window.location.hostname === '172.16.0.145' ||
      window.location.hostname === '172.16.0.137' ||
      window.location.hostname === '172.16.0.131' ||
      window.location.hostname === '172.16.0.146' ||
      window.location.hostname === '172.16.0.118' ||
      window.location.hostname === '10.20.60.69'  ||
      window.location.hostname === '192.168.0.189'
    ) {
      commonStore.devEnv = true;
    }
    // eslint-disable-next-line
  }, [rolesIDRegistry.size, loadRoleIDS, user]); //for role id

  useEffect(() => {
    const RoleSelectedIDS = rolesIDs
      .filter((x) => x.rolesId === userStore.user?.roleId)
      .map(function (i) {
        return i.itemId;
      });

    dashboardStore.setSelectedUserRoleIds(RoleSelectedIDS);

    const FilterMode0 = rolesIDs.flatMap(function (x) {
      return x.mode === 0 ? x.itemId : [];
    });
    commonStore.filterModeZero = FilterMode0;
    const FilterMode1 = rolesIDs.flatMap(function (x) {
      return x.mode === 1 ? x.itemId : [];
    });
    commonStore.filterModeOne = FilterMode1;
    const FilterMode2 = rolesIDs.flatMap(function (x) {
      return x.mode === 2 ? x.itemId : [];
    });
    commonStore.filterModeTwo = FilterMode2;
    if (RoleSelectedIDS.length > 0) {
      dashboardStore.setloadingData('done');
    }
    // eslint-disable-next-line
  }, [rolesIDs]);

  useEffect(() => {
    return () => clearSelectedActivity();
  }, [clearSelectedActivity]);

  //   useEffect(() => {
  //     if (userStore.user !== undefined && userStore.user !== null) {

  //         // dashboardStore.updateCountOrderMenu(userStore.user?.id);
  //     }
  //     // eslint-disable-next-line
  //   }, [userStore.user]);

  useEffect(() => {
    if (commonStore.token) {
      userStore.getUser().finally(() => commonStore.setAppLoaded());
    } else {
      commonStore.setAppLoaded();
    }
    // eslint-disable-next-line
  }, [commonStore.token]);

  useEffect(() => {
    if (user?.customerName !== undefined) {
      //ReportsOrderTable
      if (
        localStorage.getItem('ReportsOrderTable') === undefined ||
        localStorage.getItem('ReportsOrderTable') === null ||
        localStorage.getItem('ReportsOrderTable') === ''
      ) {
        localStorage.setItem(
          'ReportsOrderTable',
          'title,current_user,current_task,current_subtask,asset_tracking_status,status,movementdate',
        );
      }
      if (
        localStorage.getItem('InventoryReportsTable') === undefined ||
        localStorage.getItem('InventoryReportsTable') === null ||
        localStorage.getItem('InventoryReportsTable') === ''
      ) {
        localStorage.setItem(
          'InventoryReportsTable',
          'title,current_user,current_task,current_subtask,asset_tracking_status,status,movementdate',
        );
      }
      if (
        localStorage.getItem('OrderTable') === undefined ||
        localStorage.getItem('OrderTable') === null ||
        localStorage.getItem('OrderTable') === ''
      ) {
        localStorage.setItem(
          'OrderTable',
          'taskName,subTaskName,elementName,elementValue',
        );
      }
      if (
        localStorage.getItem('ProductionPlanningTable') === undefined ||
        localStorage.getItem('ProductionPlanningTable') === null ||
        localStorage.getItem('ProductionPlanningTable') === ''
      ) {
        localStorage.setItem(
          'ProductionPlanningTable',
          'title,current_user,current_task,current_subtask,asset_tracking_status,status,movementdate',
        );
      }
      if (
        localStorage.getItem('AlertsTable') === undefined ||
        localStorage.getItem('AlertsTable') === null ||
        localStorage.getItem('AlertsTable') === ''
      ) {
        localStorage.setItem(
          'AlertsTable',
          'title,task,subtask,rejectDateTime,rejectUsername,rejectMessage,resolveUsername,resolveMessage,resolveDateTime',
        );
      }
      if (
        localStorage.getItem('AssetTable') === undefined ||
        localStorage.getItem('AssetTable') === null ||
        localStorage.getItem('AssetTable') === ''
      ) {
        if (user?.customerName === 'CG') {
          localStorage.setItem(
            'AssetTable',
            'title,asset_tracking_status,movementdate,itemCreatedAt',
          );
          
        } else if(commonStore.hfcCustomerChanges){
          localStorage.setItem(
            'AssetTable',
            'title,asset_id,container_barcodes,reel_barcodes,itemCreatedAt',
          );
        }
        else if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'AssetTable',
            'title,asset_tracking_status,movementdate,itemCreatedAt,physical_sensor_barcode,asset_in_room,physical_location_Room,physical_location_shelf',
          );
        } else if (user?.customerName === 'NFAI') {
          localStorage.setItem(
            'AssetTable',
            'title,current_task,current_subtask,Asset_id',
          );
        }  else if (user?.customerName === 'Mepz' || user?.customerName === 'TNCA') {
          localStorage.setItem(
            'AssetTable',
            'file_Name,category,department,lot_No,company_Name,license_Number',
          );
        }else if (user?.customerName === 'PCPLIT') {
          localStorage.setItem(
            'AssetTable',
            'title,new_hostname,workstation_no,location,company,building,ip_address,current_username,',
          );
        } else {
          localStorage.setItem(
            'AssetTable',
            'title,asset_tracking_status,movementdate,itemCreatedAt,physical_sensor_barcode,asset_In_Vault,physical_location_vault,physical_location_shelf',
          );
        }
      }
      if (
        localStorage.getItem('IT Asset List') === undefined ||
        localStorage.getItem('IT Asset List') === null ||
        localStorage.getItem('IT Asset List') === ''
      ) {
          localStorage.setItem(
            'IT Asset List',
            'title,company,building,department,user_Or_Owner_Name,new_asset_tag,floor,rack_no,category,capacity,location,make_Or_Model_No,model_sn,remarks'
          );
      }
      if (
        localStorage.getItem('CRM Authorization') === undefined ||
        localStorage.getItem('CRM Authorization') === null ||
        localStorage.getItem('CRM Authorization') === ''
      ) {
          localStorage.setItem(
            'CRM Authorization',
            'title,client_name,process,estimate_cost,delivery_date'
          );
      }
      if (
        localStorage.getItem('CRM InWard') === undefined ||
        localStorage.getItem('CRM InWard') === null ||
        localStorage.getItem('CRM InWard') === ''
      ) {
          localStorage.setItem(
            'CRM InWard',
            'title,client_name,process,inward_remarks,delivery_date'
          );
      }
      if (
        localStorage.getItem('CRM OutWard') === undefined ||
        localStorage.getItem('CRM OutWard') === null ||
        localStorage.getItem('CRM OutWard') === ''
      ) {
          localStorage.setItem(
            'CRM OutWard',
            'title,client_name,process,outward_remarks,delivery_date'
          );
      }
      
      if (
        localStorage.getItem('CRM Physical Inspection') === undefined ||
        localStorage.getItem('CRM Physical Inspection') === null ||
        localStorage.getItem('CRM Physical Inspection') === ''
      ) {
          localStorage.setItem(
            'CRM Physical Inspection',
            'title,client_name,process,delivery_date,film_type,film_gauge,film_cleaning_(manual),film_censor_certificate,status,current_user'
          );
      }

      if (
        localStorage.getItem('CRM Ultrasonic Cleaning') === undefined ||
        localStorage.getItem('CRM Ultrasonic Cleaning') === null ||
        localStorage.getItem('CRM Ultrasonic Cleaning') === ''
      ) {
          localStorage.setItem(
            'CRM Ultrasonic Cleaning',
            'title,client_name,process,delivery_date,ultra_sonic_cleaning,status,current_user'
          );
      }

      if (
        localStorage.getItem('CRM Scanning') === undefined ||
        localStorage.getItem('CRM Scanning') === null ||
        localStorage.getItem('CRM Scanning') === ''
      ) {
          localStorage.setItem(
            'CRM Scanning',
            'title,client_name,process,delivery_date,scan_resolution,Scan_dpx-_downscale,scan_aperture,scan_file_format,scan_output_media,status,current_user'
          );
      }

      if (
        localStorage.getItem('CRM Graded DPX') === undefined ||
        localStorage.getItem('CRM Graded DPX') === null ||
        localStorage.getItem('CRM Graded DPX') === ''
      ) {
          localStorage.setItem(
            'CRM Graded DPX',
            'title,client_name,process,delivery_date,graded_output_resolution,graded_ouput_ratio,grading_colour_space,grading_specification,status,current_user'
          );
      }
      if (
        localStorage.getItem('CRM Audio') === undefined ||
        localStorage.getItem('CRM Audio') === null ||
        localStorage.getItem('CRM Audio') === ''
      ) {
          localStorage.setItem(
            'CRM Audio',
            'title,client_name,process,delivery_date,audio_input,audio_output,audio_output_fps,audio_output_bit_depth,audio_restoration,status,current_user'
          );
      }
      if (
        localStorage.getItem('CRM Restoration') === undefined ||
        localStorage.getItem('CRM Restoration') === null ||
        localStorage.getItem('CRM Restoration') === ''
      ) {
          localStorage.setItem(
            'CRM Restoration',
            'title,client_name,process,delivery_date,restoration_level,restoration_qc_-_fps,status,current_user'
          );
      }
      if (
        localStorage.getItem('CRM Mastering') === undefined ||
        localStorage.getItem('CRM Mastering') === null ||
        localStorage.getItem('CRM Mastering') === ''
      ) {
          localStorage.setItem(
            'CRM Mastering',
            'title,client_name,process,delivery_date,video_file_container,video_codec,video_resolution,video_aspect_ratio,frame_rate,picture_aspect_ratio,chroma_sampling,final_video_output,final_output_audio,status,current_user'
          );
      }
      if (
        localStorage.getItem('CRM Broadcast Channel Spec') === undefined ||
        localStorage.getItem('CRM Broadcast Channel Spec') === null ||
        localStorage.getItem('CRM Broadcast Channel Spec') === ''
      ) {
          localStorage.setItem(
            'CRM Broadcast Channel Spec',
            'title,client_name,process,delivery_date,broadcast_channel_spec,status,current_user'
          );
      }
      if (
        localStorage.getItem('CRM Deliverables') === undefined ||
        localStorage.getItem('CRM Deliverables') === null ||
        localStorage.getItem('CRM Deliverables') === ''
      ) {
          localStorage.setItem(
            'CRM Deliverables',
            'title,client_name,process,4k_raw_scan,2k_graded_dpx,2k_restored_dpx,hd_prores_with_av_sync,cleaned_audio_(wave_file),status,current_user'
          );
      }
      if (
        localStorage.getItem('HFCScan') === undefined ||
        localStorage.getItem('HFCScan') === null ||
        localStorage.getItem('HFCScan') === ''
      ) {
        localStorage.setItem('HFCScan', 'title,asset_Id,container_Barcodes,reel_Barcodes,asset_In_Vault,movement_Time');
      }
      if (
        localStorage.getItem('HFCShipper') === undefined ||
        localStorage.getItem('HFCShipper') === null ||
        localStorage.getItem('HFCShipper') === ''
      ) {
        localStorage.setItem('HFCShipper', 'title,asset_ID,print,vault');
      }
      if (
        localStorage.getItem('HFCShipperMovement') === undefined ||
        localStorage.getItem('HFCShipperMovement') === null ||
        localStorage.getItem('HFCShipperMovement') === ''
      ) {
        localStorage.setItem('HFCShipperMovement', 'title,asset_ID,print,vault');
      }
      if (
        localStorage.getItem('HFCMoveToVault') === undefined ||
        localStorage.getItem('HFCMoveToVault') === null ||
        localStorage.getItem('HFCMoveToVault') === ''
      ) {
        localStorage.setItem('HFCMoveToVault', 'title,asset_Id,container_Barcodes,reel_Barcodes,asset_In_Vault,movement_Time');
      }

      if (
        localStorage.getItem('AssetTableTag') === undefined ||
        localStorage.getItem('AssetTableTag') === null ||
        localStorage.getItem('AssetTableTag') === ''
      ) {
        localStorage.setItem('AssetTableTag', 'title,element,type');
      }
      if (
        localStorage.getItem('UnSyncTable') === undefined ||
        localStorage.getItem('UnSyncTable') === null ||
        localStorage.getItem('UnSyncTable') === ''
      ) {
        localStorage.setItem('UnSyncTable', 'file_Name,company_Name,license_Number,file_Sync_Status,created_By,reason,sync_DateTime');
      }
      if (
        localStorage.getItem('SyncTable') === undefined ||
        localStorage.getItem('SyncTable') === null ||
        localStorage.getItem('SyncTable') === ''
      ) {
        localStorage.setItem('SyncTable', 'file_Name,company_Name,license_Number,file_Sync_Status,created_By,reason,sync_DateTime');
      }
      if (
        localStorage.getItem('TagTable') === undefined ||
        localStorage.getItem('TagTable') === null ||
        localStorage.getItem('TagTable') === ''
      ) {
        localStorage.setItem(
          'TagTable',
          'title,element,type,asset_tracking_status',
        );
      }
      if (
        localStorage.getItem('CreateOrderTable') === undefined ||
        localStorage.getItem('CreateOrderTable') === null ||
        localStorage.getItem('CreateOrderTable') === ''
      ) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'CreateOrderTable',
            'title,element,type,asset_in_room',
          );
        } else {
          localStorage.setItem(
            'CreateOrderTable',
            'title,element,type,asset_In_Vault',
          );
        }
      }
      if (
        localStorage.getItem('prodPlanTable') === undefined ||
        localStorage.getItem('prodPlanTable') === null ||
        localStorage.getItem('prodPlanTable') === ''
      ) {
        if(userStore?.user?.customerName === 'NFAIReport'){
            localStorage.setItem(
          'prodPlanTable',
          'title,current_task,current_subtask,status,previousTask,previousSubtask',
        );
        }else{
           localStorage.setItem(
          'prodPlanTable',
          'title,current_user,current_task,current_subtask,asset_tracking_status,status,movementdate',
        );
        }
      }
      if (
        localStorage.getItem('InwardsTableSmall') === undefined ||
        localStorage.getItem('InwardsTableSmall') === null ||
        localStorage.getItem('InwardsTableSmall') === ''
      ) {
        localStorage.setItem(
          'InwardsTableSmall',
          'title,current_user,current_task,current_subtask,asset_tracking_status,status,movementdate',
        );
      }
      if (
        localStorage.getItem('InwardsTableBig') === undefined ||
        localStorage.getItem('InwardsTableBig') === null ||
        localStorage.getItem('InwardsTableBig') === ''
      ) {
        localStorage.setItem(
          'InwardsTableBig',
          'title,current_user,current_task,current_subtask,asset_tracking_status,status,movementdate',
        );
      }
      if (
        localStorage.getItem('OutwardsTableSmall') === undefined ||
        localStorage.getItem('OutwardsTableSmall') === null ||
        localStorage.getItem('OutwardsTableSmall') === ''
      ) {
        localStorage.setItem(
          'OutwardsTableSmall',
          'title,current_user,current_task,current_subtask,asset_tracking_status,status,movementdate',
        );
      }
      if (
        localStorage.getItem('OutwardsTableBig') === undefined ||
        localStorage.getItem('OutwardsTableBig') === null ||
        localStorage.getItem('OutwardsTableBig') === ''
      ) {
        localStorage.setItem(
          'OutwardsTableBig',
          'title,current_user,current_task,current_subtask,asset_tracking_status,status,movementdate',
        );
      }
      if (
        localStorage.getItem('DeliveryTableSmall') === undefined ||
        localStorage.getItem('DeliveryTableSmall') === null ||
        localStorage.getItem('DeliveryTableSmall') === ''
      ) {
        localStorage.setItem(
          'DeliveryTableSmall',
          'assetName,element,purpose,borrowerName,borrowerEmail,dateOfDelivery,dateOfReturn,movementTo',
        );
      }
      if (
        localStorage.getItem('DeliveryTableBig') === undefined ||
        localStorage.getItem('DeliveryTableBig') === null ||
        localStorage.getItem('DeliveryTableBig') === ''
      ) {
        localStorage.setItem(
          'DeliveryTableBig',
          'assetName,element,purpose,borrowerName,borrowerEmail,dateOfDelivery,dateOfReturn,movementTo',
        );
        //
      }
      if (
        localStorage.getItem('CustomerTable') === undefined ||
        localStorage.getItem('CustomerTable') === null ||
        localStorage.getItem('CustomerTable') === ''
      ) {
        localStorage.setItem(
          'CustomerTable',
          'customer_Name,customer_Currency,customer_Email,customer_Address,customer_Phone_Number',
        );
      }
      if (
        localStorage.getItem('VaultTable') === undefined ||
        localStorage.getItem('VaultTable') === null ||
        localStorage.getItem('VaultTable') === ''
      ) {
        localStorage.setItem(
          'VaultTable',
          'vaultName,vaultCode,vaultCountryLocation,vaultGPSLocation,vaultContactPersonName,vaultContactPersonPhone',
        );
      }
      if (
        localStorage.getItem('RoomTable') === undefined ||
        localStorage.getItem('RoomTable') === null ||
        localStorage.getItem('RoomTable') === ''
      ) {
        localStorage.setItem(
          'RoomTable',
          'roomName,roomCode,roomCountryLocation,roomGPSLocation,roomContactPersonName,roomContactPersonPhone',
        );
      }
      if (
        localStorage.getItem('DeviceTable') === undefined ||
        localStorage.getItem('DeviceTable') === null ||
        localStorage.getItem('DeviceTable') === ''
      ) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'DeviceTable',
            'RoomName,device_Type,selected_Device_Sub_Type,device_Physical_Location,reader_IP,port_Number,device_Status',
          );
        } else {
          localStorage.setItem(
            'DeviceTable',
            'vaultName,device_Type,selected_Device_Sub_Type,device_Physical_Location,reader_IP,port_Number,device_Status',
          );
        }
      }
      if (
        localStorage.getItem('ShelfRackTable') === undefined ||
        localStorage.getItem('ShelfRackTable') === null ||
        localStorage.getItem('ShelfRackTable') === ''
      ) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'ShelfRackTable',
            'roomName,shelfNumber,rackNumber,rackType',
          );
        } else if (commonStore.hfcCustomerChanges) {
          localStorage.setItem(
            'ShelfRoomTable',
            'vault,shelf,room',
          );
        }else {
          localStorage.setItem(
            'ShelfRackTable',
            'vaultName,shelfNumber,rackNumber,rackType',
          );
        }
      }
      if (
        localStorage.getItem('DepartmentTable') === undefined ||
        localStorage.getItem('DepartmentTable') === null ||
        localStorage.getItem('DepartmentTable') === ''
      ) {
        localStorage.setItem(
          'DepartmentTable',
          'department_Name,department_Code,department_Description,department_Email,department_Phone_Number',
        );
      }
      if (
        localStorage.getItem('WorkLevelTable') === undefined ||
        localStorage.getItem('WorkLevelTable') === null ||
        localStorage.getItem('WorkLevelTable') === ''
      ) {
        localStorage.setItem('WorkLevelTable', 'title');
      }
      if (
        localStorage.getItem('ReceivingTable') === undefined ||
        localStorage.getItem('ReceivingTable') === null ||
        localStorage.getItem('ReceivingTable') === ''
      ) {
        localStorage.setItem(
          'ReceivingTable',
          'receivingTitle,type,date,verify_Status',
        );
      }
      const initializeLocalStorage = (key:string, defaultValue:string) => {
        if (
          localStorage.getItem(key) === undefined ||
          localStorage.getItem(key) === null ||
          localStorage.getItem(key) === ''
        ) {
          localStorage.setItem(key, defaultValue);
        }
      };
      
      // Initialize localStorage for 'EmailTable'
      initializeLocalStorage('EmailTable', 'email,dateTime,body,status');
      
      // Initialize localStorage for 'ReadMail'
      initializeLocalStorage('ReadMail', 'email,dateTime,body,subject');
      
      // Initialize localStorage for 'UnreadMail'
      initializeLocalStorage('UnreadMail', 'email,dateTime,body,subject');
      
      if (
        localStorage.getItem('OrderRegisterTable') === undefined ||
        localStorage.getItem('OrderRegisterTable') === null ||
        localStorage.getItem('OrderRegisterTable') === ''
      ) {
        localStorage.setItem(
          'OrderRegisterTable',
          'assetName,element,purpose,borrowerName,borrowerEmail,dateOfDelivery,dateOfReturn,movementTo',
        );
      }
      if (
        localStorage.getItem('ReportsTable') === undefined ||
        localStorage.getItem('ReportsTable') === null ||
        localStorage.getItem('ReportsTable') === ''
      ) {
        if (user?.customerName === 'Restoration') {
          localStorage.setItem(
            'ReportsTable',
            'title,metadata/ title_code,metadata/ reel_name,metadata/ shot_name,metadata/ resolution,metadata/ start_frame,metadata/ end_frame,metadata/ total_frame,metadata/ team,metadata/ pl_name,current_task,current_subtask,current_user,status,metadata/ input path,metadata/ output path',
          );
        } else if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'ReportsTable',
            'title,type,element,asset_tracking_status,physical_location_Room,physical_sensor_qrcode,physical_sensor_barcode',
          );
        } else {
          localStorage.setItem(
            'ReportsTable',
            'title,type,element,asset_tracking_status,physical_location_vault,physical_sensor_qrcode,physical_sensor_barcode',
          );
        }
      }
      if (
        localStorage.getItem('DateWiseTable') === undefined ||
        localStorage.getItem('DateWiseTable') === null ||
        localStorage.getItem('DateWiseTable') === ''
      ) {
        localStorage.setItem('DateWiseTable',
        'employee_id,employee_Name,title_Code,actual_Hours,extra_Hours,fresh_Frame,correction_Frame,process_Date'
        );
      }
      if (
        localStorage.getItem('SmartTracker') === undefined ||
        localStorage.getItem('SmartTracker') === null ||
        localStorage.getItem('SmartTracker') === ''
      ) {
        if (
          [
            'Resto Admin',
            'Basic User',
            'Operator',
            'Process Lead',
            'Process Specialist',
            'Production Co-ordinator',
            'Quality Check',
            'Restoration Admin',
            'ProcessLead',
            'QC',
            'Client QC',
            'Colorization',
          ].includes(user?.roleName as string) &&
          user?.customerName === 'Restoration'
        ) {
          localStorage.setItem(
            'SmartTracker',
            'metadata/ title_code,metadata/ reel_name,metadata/ shot_name,metadata/ resolution,metadata/ start_frame,metadata/ end_frame,metadata/ total_frame,metadata/ team,metadata/ pl_name,metadata/ displayname,current_subtask,titleStatus,status,Locked By,previous owner employeeId,previous owner name,metadata/ input path,metadata/ output path',
          );
        } else if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'SmartTracker',
            'title,type,element,asset_tracking_status,physical_location_Room,physical_sensor_qrcode,physical_sensor_barcode,current_user,status',
          );
        } else if(user?.customerName === 'NFAIReport'){
          let data = 'Film_Title,Reel_No,Shot_No,Emp_ID,Emp_Name,Start_Frame,End_Frame,Total_Frames,status,Titlestatus,LockedBy,Previous_Owner_Employee_ID,Previous_Owner_Employee_Name'
          if(user?.roleName !== 'Operator') data += ',Submission_Date'
          localStorage.setItem('SmartTracker', data,);
        } else {
          localStorage.setItem(
            'SmartTracker',
            'title,type,element,asset_tracking_status,physical_location_vault,physical_sensor_qrcode,physical_sensor_barcode,current_user,status',
          );
        }
      }
      if (
        localStorage.getItem('Reel Smarttracker') === undefined ||
        localStorage.getItem('Reel Smarttracker') === null ||
        localStorage.getItem('Reel Smarttracker') === ''
      ) {
        localStorage.setItem('Reel Smarttracker', 'title_Code,reel_Name,resolution,start_Number,end_Number,total_Number,team,title_Status,status,locked_By,previous_Owner_Name,previous_Owner_EmployeeID,input_Path,output_Path');
      }
      if (
        localStorage.getItem('HistoryTable') === undefined ||
        localStorage.getItem('HistoryTable') === null ||
        localStorage.getItem('HistoryTable') === ''
      ) {
        localStorage.setItem('HistoryTable', 'username,dateTime,status');
      }
      if (
        localStorage.getItem('FilmFestivalReport') === undefined ||
        localStorage.getItem('FilmFestivalReport') === null ||
        localStorage.getItem('FilmFestivalReport') === ''
      ) {
        localStorage.setItem(
          'FilmFestivalReport',
          'title,current_user,current_task,current_subtask,asset_tracking_status,status,movementdate',
        );
      }
      if (
        localStorage.getItem('LinkExising') === undefined ||
        localStorage.getItem('LinkExising') === null ||
        localStorage.getItem('LinkExising') === ''
      ) {
        localStorage.setItem('LinkExising', 'title');
      }
      if (
        localStorage.getItem('TagTable') === undefined ||
        localStorage.getItem('TagTable') === null ||
        localStorage.getItem('TagTable') === ''
      ) {
        localStorage.setItem('TagTable', 'title,element,type');
      }
      if (
        localStorage.getItem('CreateOrderTable') === undefined ||
        localStorage.getItem('CreateOrderTable') === null ||
        localStorage.getItem('CreateOrderTable') === ''
      ) {
        localStorage.setItem('CreateOrderTable', 'title,element,type');
      }
      if (
        localStorage.getItem('AllocateUser') === undefined ||
        localStorage.getItem('AllocateUser') === null ||
        localStorage.getItem('AllocateUser') === ''
      ) {
        localStorage.setItem('AllocateUser', 'title,element,type');
      }
      if (
        localStorage.getItem('MasterTable') === undefined ||
        localStorage.getItem('MasterTable') === null ||
        localStorage.getItem('MasterTable') === ''
      ) {
        localStorage.setItem(
          'MasterTable',
          'title,current_user,current_task,current_subtask,asset_tracking_status,status,movementdate',
        );
      }
      if (
        localStorage.getItem('AllocateUserScan') === undefined ||
        localStorage.getItem('AllocateUserScan') === null ||
        localStorage.getItem('AllocateUserScan') === ''
      ) {
        localStorage.setItem('AllocateUserScan', 'title,element,type');
      }
      if (
        localStorage.getItem('viewHistoryTable') === undefined ||
        localStorage.getItem('viewHistoryTable') === null ||
        localStorage.getItem('viewHistoryTable') === ''
      ) {
        localStorage.setItem('viewHistoryTable', 'username,status,dateTime');
      }
      if (
        localStorage.getItem('viewTemplateTable') === undefined ||
        localStorage.getItem('viewTemplateTable') === null ||
        localStorage.getItem('viewTemplateTable') === ''
      ) {
        localStorage.setItem(
          'viewTemplateTable',
          'elementName,elementValue,taskName,subTaskName,status,dateTime',
        );
      }
      if (!localStorage.getItem('QuickScan')) {
        localStorage.setItem('QuickScan', 'title,element,type');
      }
      if (!localStorage.getItem('Movementview')) {
        localStorage.setItem(
          'Movementview',
          'username,status,fromTime,toTime,directionFrom,directionTo',
        );
      }

      // Inventory reports
      if (!localStorage.getItem('NewAssetAdded')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'NewAssetAdded',
            'title,asset_tracking_status,movementdate,itemCreatedAt,physical_sensor_barcode,asset_in_room,physical_location_Room,physical_location_shelf',
          );
        } else {
          localStorage.setItem(
            'NewAssetAdded',
            'title,asset_tracking_status,movementdate,itemCreatedAt,physical_sensor_barcode,asset_In_Vault,physical_location_vault,physical_location_shelf',
          );
        }
      }
      if (!localStorage.getItem('CurrentMonthAssetCANMovement')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'CurrentMonthAssetCANMovement',
            'title,asset_tracking_status,movementdate,itemCreatedAt,physical_sensor_barcode,asset_in_room,physical_location_Room,physical_location_shelf',
          );
        } else {
          localStorage.setItem(
            'CurrentMonthAssetCANMovement',
            'title,asset_tracking_status,movementdate,itemCreatedAt,physical_sensor_barcode,asset_In_Vault,physical_location_vault,physical_location_shelf',
          );
        }
      }
      if (!localStorage.getItem('PendingReturnsFromBorrowers')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'PendingReturnsFromBorrowers',
            'title,asset_tracking_status,movementdate,itemCreatedAt,physical_sensor_barcode,asset_in_room,physical_location_Room,physical_location_shelf',
          );
        } else {
          localStorage.setItem(
            'PendingReturnsFromBorrowers',
            'title,asset_tracking_status,movementdate,itemCreatedAt,physical_sensor_barcode,asset_In_Vault,physical_location_vault,physical_location_shelf',
          );
        }
      }
      if (!localStorage.getItem('AssetsScheduledForCleaning')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'AssetsScheduledForCleaning',
            'title,asset_tracking_status,movementdate,itemCreatedAt,physical_sensor_barcode,asset_in_room,physical_location_Room,physical_location_shelf',
          );
        } else {
          localStorage.setItem(
            'AssetsScheduledForCleaning',
            'title,asset_tracking_status,movementdate,itemCreatedAt,physical_sensor_barcode,asset_In_Vault,physical_location_vault,physical_location_shelf',
          );
        }
      }
      if (!localStorage.getItem('AssetsCleaned')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'AssetsCleaned',
            'title,asset_tracking_status,movementdate,itemCreatedAt,physical_sensor_barcode,asset_in_room,physical_location_Room,physical_location_shelf',
          );
        } else {
          localStorage.setItem(
            'AssetsCleaned',
            'title,asset_tracking_status,movementdate,itemCreatedAt,physical_sensor_barcode,asset_In_Vault,physical_location_vault,physical_location_shelf',
          );
        }
      }
      if (!localStorage.getItem('DigitalizationPriority')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'DigitalizationPriority',
            'title,asset_tracking_status,movementdate,itemCreatedAt,physical_sensor_barcode,asset_in_room,physical_location_Room,physical_location_shelf',
          );
        } else {
          localStorage.setItem(
            'DigitalizationPriority',
            'title,asset_tracking_status,movementdate,itemCreatedAt,physical_sensor_barcode,asset_In_Vault,physical_location_vault,physical_location_shelf',
          );
        }
      }
      // order reports

      if (!localStorage.getItem('Received')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'Received',
            'title,type,element,order_tracking,current_user,asset_in_room,movementdate,physical_location_Room,physical_location_shelf,global_positioning_system',
          );
        } else {
          localStorage.setItem(
            'Received',
            'title,type,element,order_tracking,current_user,asset_In_Vault,movementdate,physical_location_vault,physical_location_shelf,global_positioning_system',
          );
        }
      }
      if (!localStorage.getItem('WaitingForApproval')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'WaitingForApproval',
            'title,type,element,order_tracking,current_user,asset_in_room,movementdate,physical_location_Room,physical_location_shelf,global_positioning_system',
          );
        } else {
          localStorage.setItem(
            'WaitingForApproval',
            'title,type,element,order_tracking,current_user,asset_In_Vault,movementdate,physical_location_vault,physical_location_shelf,global_positioning_system',
          );
        }
      }
      if (!localStorage.getItem('Approved')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'Approved',
            'title,type,element,order_tracking,current_user,asset_in_room,movementdate,physical_location_Room,physical_location_shelf,global_positioning_system',
          );
        } else {
          localStorage.setItem(
            'Approved',
            'title,type,element,order_tracking,current_user,asset_In_Vault,movementdate,physical_location_vault,physical_location_shelf,global_positioning_system',
          );
        }
      }
      if (!localStorage.getItem('InProgress')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'InProgress',
            'title,type,element,order_tracking,current_user,asset_in_room,movementdate,physical_location_Room,physical_location_shelf,global_positioning_system',
          );
        } else {
          localStorage.setItem(
            'InProgress',
            'title,type,element,order_tracking,current_user,asset_In_Vault,movementdate,physical_location_vault,physical_location_shelf,global_positioning_system',
          );
        }
      }
      if (!localStorage.getItem('Ready')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'Ready',
            'title,type,element,order_tracking,current_user,asset_in_room,movementdate,physical_location_Room,physical_location_shelf,global_positioning_system',
          );
        } else {
          localStorage.setItem(
            'Ready',
            'title,type,element,order_tracking,current_user,asset_In_Vault,movementdate,physical_location_vault,physical_location_shelf,global_positioning_system',
          );
        }
      }
      if (!localStorage.getItem('Delivered')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'Delivered',
            'title,type,element,order_tracking,current_user,asset_in_room,movementdate,physical_location_Room,physical_location_shelf,global_positioning_system',
          );
        } else {
          localStorage.setItem(
            'Delivered',
            'title,type,element,order_tracking,current_user,asset_In_Vault,movementdate,physical_location_vault,physical_location_shelf,global_positioning_system',
          );
        }
      }
      if (!localStorage.getItem('Returned')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'Returned',
            'title,type,element,order_tracking,current_user,asset_in_room,movementdate,physical_location_Room,physical_location_shelf,global_positioning_system',
          );
        } else {
          localStorage.setItem(
            'Returned',
            'title,type,element,order_tracking,current_user,asset_In_Vault,movementdate,physical_location_vault,physical_location_shelf,global_positioning_system',
          );
        }
      }

      // inward
      if (!localStorage.getItem('Verify')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'Verify',
            'title,element,type,order_tracking,asset_in_room,movement_Time,physical_location_Room,physical_location_shelf,global_positioning_system',
          );
        } else {
          localStorage.setItem(
            'Verify',
            'title,element,type,order_tracking,asset_In_Vault,movement_Time,physical_location_vault,physical_location_shelf,global_positioning_system',
          );
        }
      }
      if (!localStorage.getItem('Approve')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'Approve',
            'title,element,type,order_tracking,asset_in_room,movement_Time,physical_location_Room,physical_location_shelf,global_positioning_system',
          );
        } else {
          localStorage.setItem(
            'Approve',
            'title,element,type,order_tracking,asset_In_Vault,movement_Time,physical_location_vault,physical_location_shelf,global_positioning_system',
          );
        }
      }
      if (!localStorage.getItem('PickerAssign')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'PickerAssign',
            'title,element,type,order_tracking,asset_in_room,movement_Time,physical_location_Room,physical_location_shelf,global_positioning_system',
          );
        } else {
          localStorage.setItem(
            'PickerAssign',
            'title,element,type,order_tracking,asset_In_Vault,movement_Time,physical_location_vault,physical_location_shelf,global_positioning_system',
          );
        }
      }
      if (!localStorage.getItem('MoveToVault')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'MoveToVault',
            'title,element,type,order_tracking,asset_in_room,movement_Time,physical_location_Room,physical_location_shelf,global_positioning_system',
          );
        } else {
          localStorage.setItem(
            'MoveToVault',
            'title,element,type,order_tracking,asset_In_Vault,movement_Time,physical_location_vault,physical_location_shelf,global_positioning_system',
          );
        }
      }

      // outward
      if (!localStorage.getItem('Unvault')) {
        localStorage.setItem(
          'Unvault',
          'title,type,element,order_tracking,current_task,current_subtask,status',
        );
      }
      if (!localStorage.getItem('ApproveOutward')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'ApproveOutward',
            'title,type,element,order_tracking,asset_in_room,purpose',
          );
        } else {
          localStorage.setItem(
            'ApproveOutward',
            'title,type,element,order_tracking,asset_In_Vault,purpose',
          );
        }
      }
      if (!localStorage.getItem('VerifyOutward')) {
        localStorage.setItem(
          'VerifyOutward',
          'title,type,element,order_tracking,current_task,current_subtask,status',
        );
      }
      if (!localStorage.getItem('Move')) {
        localStorage.setItem(
          'Move',
          'title,type,element,order_tracking,borrowerName,movementTo,purpose',
        );
      }
      if (!localStorage.getItem('Package')) {
        localStorage.setItem(
          'Package',
          'title,type,element,order_tracking,borrowerName,movementTo,purpose',
        );
      }
      if (!localStorage.getItem('AssignPickerOutward')) {
        localStorage.setItem(
          'AssignPickerOutward',
          'title,type,borrowerName,order_tracking',
        );
      }
      if (!localStorage.getItem('Billing')) {
        localStorage.setItem(
          'Billing',
          'title,type,order_tracking,billType,amount',
        );
      }

      if (!localStorage.getItem('TagOrder')) {
        if (user?.customerName === 'LVP CMS - AM') {
          localStorage.setItem(
            'TagOrder',
            'title,type,element,order_tracking,current_user,asset_in_room,movementdate,physical_location_Room,physical_location_shelf,global_positioning_system',
          );
        } else {
          localStorage.setItem(
            'TagOrder',
            'title,type,element,order_tracking,current_user,asset_In_Vault,movementdate,physical_location_vault,physical_location_shelf,global_positioning_system',
          );
        }
      }

      if (!localStorage.getItem('manDaysReport')) {
        localStorage.setItem(
          'manDaysReport',
          'title,employee,description,total_Frame,estimate_Matte_Paint_Mandays,actual_Matte_Paint_Mandays,estimate_Paint_Mandays,actual_Paint_Mandays,estimate_Comp_Mandays,actual_Comp_Mandays,estimate_Roto_Mandays,actual_Roto_Mandays,estimate_3D_Mandays,actual_3D_Mandays,metadata',
        );
      }
      if (!localStorage.getItem('viewShots')) {
        localStorage.setItem(
          'viewShots',
          'reel,shot,startFrame,endFrame,numberOfFrameAffected,startTimeCode,endTimeCode,complexity,defects',
        );
      }
      if (!localStorage.getItem('CrmAssetTrack')) {
        localStorage.setItem(
          'CrmAssetTrack',
          "title,company,building,department,location,category,make_Or_Model_No,model_Sn,asset_Moved_To,handover_date,receiving_date,remarks,history,edit,isReceived",
        );
      }
       if (!localStorage.getItem('NFAIRestorationDashboard')) {
        localStorage.setItem(
          'NFAIRestorationDashboard',
          "title,current_task,current_subtask,status,previousTask,previousSubtask",
        );
      }
    }
    //eslint-disable-next-line
  }, [user?.customerName, user?.roleName, commonStore.hfcCustomerChanges]);
  const handleCutlistStausReport = () =>{
    //eslint-disable-next-line
    return commonStore.NFAIReportCustomer ? <NFAI_Cutliststatusreport /> : <Cutliststatusreport />
  }
  const routeComponent = (comp: JSX.Element) => {
    return !userStore.isLoggedIn ? <Navigate to="/" /> : comp;
  };

  if (!commonStore.appLoaded)
    return <LoadingComponent content="Loading app..." />;

  return isOffline ? (
    <OfflineDetector />
  ) : (
    <div>
      <ToastContainer position="bottom-right" closeButton />
      <ModalContainer />
      <ModalSmall />
      {userStore.isLoggedIn && (
        <>
          <NavBar />
          <SidebarContainer />
          <Sidebar.Pushable style={{ overflow: 'hidden' }}>
            <Sidebar.Pusher dimmed={false}>
              <Container>
                <div className="app-container">
                  {!!(userStore?.user?.isFirstTimeLogin === 'true') && (
                    <ResetPasswordOnFirstEverLogin />
                  )}
                </div>
              </Container>
            </Sidebar.Pusher>
          </Sidebar.Pushable>
        </>
      )}
      <Routes>
        <Route element={<HomePage />} path="/" />
        <Route element={routeComponent(<SingUpForm />)} path="/register" />
        <Route
          element={routeComponent(<MovementGate />)}
          path="/track/:id/:gate/:direction"
        />
        <Route element={routeComponent(<Dashboard />)} path="/dashboard" />
        <Route
          element={routeComponent(<MediaAssetDashboard />)}
          path="/mediaAssets"
        />
        <Route
          element={routeComponent(<CommunicationSetting />)}
          path="/communication-setting"
        />
        <Route
          element={routeComponent(<ActivityDetails />)}
          path="/mediaAssets/:id"
        />
        {['/createAsset', '/manage/:id', '/create/:id'].map((path) => (
          <Route
            key={location.key}
            path={path}
            element={routeComponent(<AssetForm />)}
          />
        ))}
        {['/physicalAssetIdentifier', '/manage/:id'].map((path) => (
          <Route
            key={location.key}
            path={path}
            element={routeComponent(<PhysicalAssetIdentifier />)}
          />
        ))}
        <Route
          element={routeComponent(<AssignUserScan />)}
          path={'/assignuser'}
        />
        <Route
        // eslint-disable-next-line
          element={routeComponent(commonStore.NFAIReportCustomer ? <NFAI_Restoration_SmartFlow/> : <SmartFlow/>)}
          path={
            '/smart_flow/asset/:assetId/element/:elementId/template/:templateId'
          }
        />
        <Route
          element={routeComponent(<AssetScan isShowAssetProp={false} />)}
          path={'/asset_details/:id'}
        />
        <Route
          element={routeComponent(<AssetScan isShowAssetProp={true} />)}
          path="/items/:id"
        />
        <Route element={routeComponent(<TestErrors />)} path="/errors" />
        <Route element={routeComponent(<Message />)} path="/message" />
        <Route
          element={routeComponent(<VaultMasterForm viewPort={true} />)}
          path="/registerRoom"
        />
        <Route
          element={routeComponent(<VaultMasterForm viewPort={true} />)}
          path="/registerVault"
        />
        <Route
          element={routeComponent(<VaultMasterTable />)}
          path="/viewVault"
        />
        <Route
          element={routeComponent(<VaultMasterTable />)}
          path="/viewRoom"
        />
        <Route
          element={routeComponent(<DeviceMasterForm />)}
          path="/registerDevice"
        />
        <Route element={routeComponent(<Message />)} path="/message" />

        <Route
          element={routeComponent(<DeviceMasterTable />)}
          path="/viewDevice"
        />

        <Route
          element={routeComponent(<ShelfRackMasterForm viewPort={true} />)}
          path="/registerShelfRack"
        />
        <Route
          element={routeComponent(<ShelfRackMasterTable />)}
          path="/viewShelfRack"
        />

        <Route
          element={routeComponent(<DepartmentMasterForm />)}
          path="/registerDepartment"
        />
        <Route
          element={routeComponent(<DepartmentMasterTable />)}
          path="/viewDepartment"
        />

        <Route
          element={routeComponent(<CustomerMasterForm />)}
          path="/registerCustomer"
        />
        <Route
          element={routeComponent(<CustomerMasterTable />)}
          path="/viewCustomer"
        />

        <Route
          element={routeComponent(<MetaDataConfiguration />)}
          path="/metadataconfiguration"
        />
        <Route
          element={routeComponent(<MasterRegisterForm isMaster={false} />)}
          path="/registerWorkLevelMaster"
        />
        <Route
          element={routeComponent(<MasterRegisterForm isMaster={true} />)}
          path="/createMaster"
        />
        <Route
          element={routeComponent(<WorkLevelMasterTable />)}
          path="/viewWorkLevelMaster"
        />
        <Route
          element={routeComponent(<Generatelabel />)}
          path="/generatelabel"
        />
        <Route element={routeComponent(<APISetting />)} path="/apisetting" />
        <Route
          element={routeComponent(<PivotTableMain />)}
          path="/pivottable"
        />
        <Route element={routeComponent(<TaskKanban />)} path="/Kanban" />
        <Route element={routeComponent(<MepzDataSync />)} path="/DataSync" />
        <Route element={routeComponent(<MepzDashboard />)} path="/mepzDashboard" />
        <Route element={routeComponent(<Scan />)} path="/Scan" />
        <Route
          element={routeComponent(<AccessDenied />)}
          path="/accessdenied"
        />
        <Route element={routeComponent(<ServerError />)} path="/server-error" />
        <Route element={routeComponent(<UserList />)} path="/userlist" />
        <Route element={routeComponent(<MetaDataReport2 />)} path="/reports" />
        <Route element={routeComponent(<QcTable />)} path="/qcTable" />
        <Route
          element={routeComponent(<TitleWiseSummary />)}
          path="/TitleSummaryReport"
        />
        <Route
          element={routeComponent(<CommonSummaryReport title={'reel'} />)}
          path="/ReelSummaryReport"
        />
        <Route
          element={routeComponent(<CommonSummaryReport title="PL" />)}
          path="/PLSummaryReport"
        />
        <Route
          element={routeComponent(<OperatorPerformance />)}
          path="/operatorPerformance"
        />
        <Route
          element={routeComponent(<OperatorPerformanceColorization />)}
          path="/operatorPerformanceColorization"
        />
        <Route
          element={routeComponent(<ColorizationMonthlyProductivityReport />)}
          path="/colorizationMonthlyProductivityReport"
        />
        <Route
         element={routeComponent(<MultipleDeleteOption />)}
         path='/multipleDeleteOptionForTasks'
        />
        <Route
          element={routeComponent(<CRMAssetTracking />)}
          path='/crmAssetTracking'
        />
        <Route
          element={routeComponent(<ManDaysReport />)}
          path="/manDaysReport"
        />
        <Route
          element={routeComponent(<RolesAndPermissions />)}
          path="/roles"
        />
        <Route
          element={routeComponent(<WorkflowSettings />)}
          path="/workflowsettings"
        />
        <Route
          element={routeComponent(<WorkLevelMasterTable />)}
          path="/viewWorkLevelMaster"
        />
        <Route
          element={routeComponent(<UserProfile />)}
          path="/profile/:username"
        />
        <Route
          element={routeComponent(<EditProfile />)}
          path="/profile/:username/edit"
        />
        <Route
          element={routeComponent(<SaveAsPivot />)}
          path="/pivotsaveasreport/:id"
        />
        <Route
          element={routeComponent(<FilmFestivalReport />)}
          path="/filmfestivalreport"
        />
        <Route
          element={routeComponent(<DynamicMasterTable />)}
          path="/mastersreport/:id"
        />
        <Route element={routeComponent(<AssetForm />)} path="/create/:id" />
        <Route
          element={routeComponent(<AllocateUser />)}
          path="/allocateuser"
        />
        <Route element={routeComponent(<QuickScan />)} path="/QuickScan" />
        <Route
          element={routeComponent(<DashboardConfiguration />)}
          path="/dashboard_configuration"
        />
        <Route element={routeComponent(<ShotwiseQC />)} path="/assetReport" />
        <Route
          element={routeComponent(<DynamicDashboard />)}
          path="/dynamic_dashboard"
        />
        <Route
           element={routeComponent(<NFAITimeSheetProcess />)}
           path="/NFAIProcess"
        />
        <Route
           element={routeComponent(<ProductionDashboard />)}
           path="/MasteringDashboard"
        />
        <Route
          element={routeComponent(
            <NewMasterTableForm
              metaData={[]}
              automaticPdf={false}
              setIsTableUpdated={undefined}
            />,
          )}
          path="/newMasterForm/:id"
        />
        <Route
          element={routeComponent(
            <MasterTable
              metaData={[]}
              downloadBtnMode={1}
              deleteBtnMode={1}
              editBtnMode={1}
              automaticPdf={false}
            />,
          )}
          path="/newMasterReport/:id"
        />
        <Route element={routeComponent(<ElasticSearch />)} path="/search" />
        <Route
          element={routeComponent(<QualityHistory />)}
          path="/defectReport"
        />
        <Route
          element={routeComponent(<AllCompletedReport />)} 
          path="/CulistAllCompleteReport"
        />
        <Route
          element={routeComponent(<NFAIDefectReport />)} 
          path="/NFAIDefectReport"
        />
        <Route
          element={routeComponent(<SmartFlow />)}
          path="/smartTracker"
        />
        <Route
          element={handleCutlistStausReport()}
          path="/Cutliststatusreport"
        />
        <Route
          element={<OperatorPerformanceNFAIReport/>}
          path="/operatorPerformanceNFAI"
        />
        <Route
          element={<QualityCheckPerformanceReport />}
          path="/QualityCheckPerformanceReport"
        />
        <Route
          element={routeComponent(<QualityTeamTitlewisePerformace />)}
          path="/QualityTeamTitlewisePerformace"
        />
        <Route
          element={routeComponent(<TitleWiseProductionHoursReport />)}
          path="/TitleWiseProductionHoursReport"
        />
        <Route
          element={routeComponent(<EmployeeDetailsReport />)}
          path="/EmployeeDetailsReport"
        />
         <Route
          element={routeComponent(<MISProductionAndQualityReport />)}
          path="/MISProductionAndQualityReport"
        />
        <Route
          element={routeComponent(<ClusterReport />)}
          path="/ClusterReport"
        />
        <Route
          element={routeComponent(<TitleDashboardReport />)}
          path="/TitleDashboardReport"
        />
         <Route
          element={routeComponent(<ClusterCapacityReport />)}
          path="/ClusterCapacityReport"
        />
        <Route
          element={routeComponent(<DaywiseHoursAnalyzer />)}
          path="/DaywiseHoursAnalyzer"
        />
        <Route
          element={routeComponent(<TitleProductivityReport />)}
          path="/TitleProductivityReport"
        />
        <Route
          element={routeComponent(<HCDelayUpdate />)}
          path="/HCDelayUpdate"
        />
        <Route
          element={routeComponent(<ManualHoursAdd />)}
          path="/ManualHoursAdd"
        />
        <Route
          element={routeComponent(<MonthlyManualHoursAdd />)}
          path="/MonthlyManualHoursAdd"
        />
        <Route
          element={routeComponent(<NFAIManualHoursAdd />)}
          path="/NFAIManualHoursAdd"
        />
        <Route
          element={routeComponent(<NFAIMonthlyManualHoursAdd />)}
          path="/NFAIMonthlyManualHoursAdd"
        />
        <Route
          element={routeComponent(<HoursMissingEmployeeDetails />)}
          path="/HoursMissingEmployeeDetails"
        />
        <Route
          element={routeComponent(<RestorationProductivityReport />)}
          path="/RestorationProductivityReport"
        />
        <Route
          element={routeComponent(<HoneyCombStatusReport />)}
          path="/HoneyCombStatusReport"
        />
        <Route
          element={routeComponent(<MonthlyProductivityReport />)}
          path="/MonthlyProductivityReport"
        />
        <Route
           element={routeComponent(<ProductionTitleDeactivation/>)}
           path="/ProductionTitleDeactivation"
         />
        <Route
          element={routeComponent(<OperationReport />)}
          path="/OperationalReport"
        />
          <Route
          element={routeComponent(<ClusterWiseOperationalReport />)}
          path="/ClusterWiseOperationalReport"
        />
         <Route
          element={routeComponent(<CreateNewTitleInventory />)}
          path="/CreateNewTitleInventory"
        />
        <Route
          element={routeComponent(<FilmAnaysisAndRepairReport />)}
          path="/FilmAnalysis_RepairReport"
        />
        <Route
          element={routeComponent(<AssignReportingHeadHierarchy />)}
          path="/AssignReportingHeadHierarchy"
        />
        <Route
          element={routeComponent(<CommunicationSettingForDyanamicDashboard />)}
          path="/CommSettingForDynDash/:id"
        />
        <Route element={routeComponent(<EmployeeUnlock />)} path="/ADLUnlock" />
        <Route element={routeComponent(<ShiftRoster />)} path="/ShiftRoster" />
        <Route element={routeComponent(<ShiftMaster />)} path="/ShiftMaster" />
        <Route element={routeComponent(<ShiftModify />)} path="/ShiftModify" />
        <Route
          element={routeComponent(<PCProcessCsvReport />)}
          path="/PC_Process_CsvReport"
        />
        <Route
        // eslint-disable-next-line
          element={routeComponent(<CRM_SmartFlow />)}
          path="/CRM_SmartFlow"
        />
        <Route
        // eslint-disable-next-line
          element={routeComponent(<ItAssetListForCRM />)}
          path="/IT_Asset_List"
        />
                    <Route
                      // eslint-disable-next-line
                        element={routeComponent(<ClientCorrectionReport />)}
                        path="/ClientCorrection"
                      />
        {/* InstantPage Login Routes */}

        <Route element={<Vaultloginform />} path="/instantPage" />
        <Route element={<CustomerCard />} path="/CustomerList" />
        <Route element={<FormMainpage />} path="/TemplateList" />

        <Route element={<AssetTracking />} path="/asset_track" />
        <Route element={<NotFound />} />
      </Routes>
      {commonStore.RestorationCustomer && TrackingReportStore.FooterOperatorRemainter !== '' && <div> <MarqueeComponent /></div>}
    
    </div>
  );
}

export default observer(App);
